<template>
  <div
    v-if="Object.keys(companyInfoNotEmptyOnly).length"
    class="company-info mod-job-info"
    data-test="company-detail-others"
  >
    <preview-job-comments
      :comments="commentHighlights"
      :is-show="isShowComment"
      v-on="$listeners"
    />
    <div
      v-if="isShowTextCount"
      class="pega-count-moji-area"
    >
      <preview-text-count
        v-for="(value,key,index) in companyInfoNotEmptyOnly"
        :key="index"
        class="mb5"
        :name="columnName[key]"
        :count-target="value"
      />
    </div>
    <dl v-if="companyInfo.established.value">
      <dt>設立</dt>
      <dd>
        <p
          :id="targetIdMap.established"
          class="pega-pre-wrap"
          data-test="established"
          v-text="companyInfo.established.value"
        />
      </dd>
    </dl>
    <dl
      v-if="containsAnyEmployeeDetails"
      data-test="employee-details"
    >
      <dt>従業員数</dt>
      <dd>
        <p
          v-if="companyInfo.employeesNum.value"
          :id="targetIdMap.employeesNum"
          data-test="employees-num"
        >
          {{ companyInfo.employeesNum.value }}
        </p>
        <p
          v-if="companyInfo.averageAge.value"
          :id="targetIdMap.averageAge"
          data-test="average-age"
        >
          平均年齢／{{ companyInfo.averageAge.value }}
        </p>
        <p
          v-if="companyInfo.employeesSexRatio.value"
          :id="targetIdMap.employeesSexRatio"
          data-test="employees-sex-ratio"
        >
          男女比／{{ companyInfo.employeesSexRatio.value }}
        </p>
        <p
          v-if="companyInfo.middleEnterRatio.value"
          :id="targetIdMap.middleEnterRatio"
          data-test="middle-enter-ratio"
        >
          中途入社者の割合／{{ companyInfo.middleEnterRatio.value }}
        </p>
      </dd>
    </dl>
    <dl v-if="companyInfo.capital.value">
      <dt>資本金</dt>
      <dd>
        <p
          :id="targetIdMap.capital"
          data-test="capital"
          class="pega-pre-wrap"
          v-text="companyInfo.capital.value"
        />
      </dd>
    </dl>
    <dl v-if="companyInfo.salesAmount.value">
      <dt>売上高</dt>
      <dd>
        <p
          :id="targetIdMap.salesAmount"
          data-test="sales-amount"
          class="pega-pre-wrap"
          v-text="companyInfo.salesAmount.value"
        />
      </dd>
    </dl>
    <dl
      v-if="companyInfo.presidentName.value"
      data-test="president"
    >
      <dt>代表者</dt>
      <dd>
        <p
          :id="targetIdMap.presidentName"
          data-test="president-name"
          class="pega-pre-wrap"
          v-text="companyInfo.presidentName.value"
        />
        <p
          v-if="companyInfo.presidentHistory.value"
          :id="targetIdMap.presidentHistory"
          data-test="president-history"
          class="pega-pre-wrap"
          v-text="'代表者略歴／' + companyInfo.presidentHistory.value"
        />
      </dd>
    </dl>
  </div>
</template>

<style lang="scss" scoped>
@use "@/styles/preview/pc/base" as *;

div.mod-job-info{
  margin: unset;
  dt, dd {
    border-top: 1px solid #bdbdbd !important;
    border-bottom: unset !important;
  }
}
</style>

<script>
import PreviewJobComments from '@/components/molecules/PreviewJobComments'
import PreviewTextCount from '@/components/atoms/PreviewTextCount'
import jobPreviewCommon from '@/lib/jobPreviewCommon'
import jobPreviewVisibilityCommon from '@/lib/jobPreviewVisibilityCommon'
import _ from 'lodash'

export default {
  components: {
    PreviewJobComments,
    PreviewTextCount
  },
  mixins: [jobPreviewCommon, jobPreviewVisibilityCommon],
  props: {
    companyInfo: {
      type: Object,
      required: true
    },
    commentHighlights: {
      type: Array,
      default: () => []
    },
    isShowComment: {
      type: Boolean,
      required: true
    },
    isShowTextCount: {
      type: Boolean,
      required: true
    }
  },
  computed: {
    columnName () {
      return {
        established: '設立',
        employeesNum: '従業員数',
        averageAge: '平均年齢',
        employeesSexRatio: '男女比',
        middleEnterRatio: '中途入社割合',
        capital: '資本金',
        salesAmount: '売上高',
        presidentName: '代表者',
        presidentHistory: '代表者略歴'
      }
    },
    companyInfoNotEmptyOnly () {
      return _.omitBy(this.companyInfo, v => _.isEqual(v.value, ''))
    }
  },
  mounted () {
    this.commentHighlights.forEach((commentHighlight) => {
      this.setHighlight(commentHighlight)
    })
  }
}
</script>
